import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import CustomReactQuill2 from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill2";
import { descriptionvalidation } from "../../../Common/commonvalidation";

export default function ModelDeliverables({
  setFormData,
  deliverables,
  setModaldeliverables,
  handleInputExpecteddeliverables,
  hitApi,
}) {
  const initialValues = {
    deliverables: deliverables || "",
  };

  const validationSchema = Yup.object().shape({
    deliverables: descriptionvalidation,
  });

  const handleSubmit = (values) => {
    handleInputExpecteddeliverables({
      target: { name: "deliverables", value: values.deliverables },
    });
    setModaldeliverables(false);
    hitApi();

    setFormData((prevFormData) => ({
      ...prevFormData,
      deliverables: values.deliverables,
    }));
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values }) => (
        <Form>
          <button
            onClick={() => setModaldeliverables(false)}
            className="btn close-button d-block"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <ModalBody>
            {/* <h4>Edit Deliverables</h4> */}
            <div className="form-group">
              <CustomReactQuill2
                title={"Enter Deliverables"}
                value={values.deliverables}
                setFieldValue={setFieldValue}
                name={"deliverables"}
              />
              <ErrorMessage
                name="deliverables"
                component="div"
                className="error"
              />
            </div>
          </ModalBody>
          <div className="modal-footer ">
            <button className="btn" type="submit">
              Save
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
